<template>
  <div class="align-center-main">

       <!-- 商城banner -->
      <Swiper :bannerList="bannerList"></Swiper>


      <section>
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="pageType">
          <el-breadcrumb-item :to="{ path: '/shoppingMall/mall' }">主页</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageType.name}}</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 商品分类展示 -->
        <div class="checkProduct fl" v-if="pageType" >
          <!-- 多选框 -->
          <el-checkbox-group
            v-model="checked2ndCategory"
            @change="checkboxChange()"
            v-if="pageType"
            >
            <el-checkbox class="checkbox" v-for="v in pageType.children" :label="v.id" :key="v.id">{{v.name}}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="product fr clearfix" v-if="showProductList.length > 0" v-loading="loading">
          <ul class="clearfix">
            <li v-for="(v, i) in showProductList" :key="i" class="boxShadow" @click="$router.push({ path: `/shoppingMall/productDetalis` , query: { id:v.id, categoryId: v.categoryId}})">
              <img :src="v.thumb[0].img" alt="">
              <div class="title">
                <h4 class="textOver">{{ v.productName }}</h4>
                <p class="price">￥{{ v.price /100 | PriceFilter}}</p>
              </div>
            </li>
          </ul>
          <div class='pages main-pagination' v-if="searchStatus?searchPageTotal>12:pageTotal>12">
            <el-pagination :page-size="12" layout="prev, pager, next, jumper" background @current-change="handleCurrentChange" :total="searchStatus?searchPageTotal:pageTotal"></el-pagination>
          </div>
        </div>
      </section>
      <Nothing v-if="showProductList.length <= 0 && !loading"></Nothing>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swiper from '@/components/Swiper';
// import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return{
      categoryId: '',
      bannerList: [],
      productList: [],
      showProductList: [],
      pageType: null,
      pageIndex: 1,
      pageTotal: 0,
      // 使用多选框搜索
      searchStatus: false,
      searchPageIndex: 1,
      searchPageTotal: 0,
      checked2ndCategory: [],
      changTime: 5000,
      maskFlag: false,
      videoUrl: null,
      loading: true,
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user']),
  },
  methods: {
    getBannerList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/category/banner/list`,{
        parkId: this.currentParkId,
        categoryId: this.categoryId,
        currPage: 1,
        pageRows: 50,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.bannerList = res.resData.pageList;
        }
      });
    },
    getProductsList(){
      // this.productList = []
      // this.showProductList = []
      // this.pageType = null
      this.loading = true;
      let params = {
        currPage: this.pageIndex,
        pageRows: 12,
        categoryId: this.categoryId,
      }
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/list`,params)
      .then((response) => {
        this.loading = false;
        const res = response.data;
        if (res.resCode === '10000') {
          this.productList = res.resData.pageList ? res.resData.pageList : [];
          this.showProductList = res.resData.pageList ? res.resData.pageList : [];
          this.pageType = res.resData.pageType? res.resData.pageType[0]: null
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },

    getSearch(){
      this.loading = true;
      let params = {
        categoryIdList: this.checked2ndCategory,
        currPage: this.searchPageIndex,
        pageRows:12,
      }
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/categoryid/list`,params)
      .then((response) => {
        this.loading = false;
        const res = response.data;
        if (res.resCode === '10000') {
          if (res.resData.pageList) {
            this.showProductList = res.resData.pageList
            this.searchPageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          }
        }
      })
    },

    handleCurrentChange(val) {
      if (this.searchStatus) {
        this.searchPageIndex = val;
        this.getSearch();
      } else {
        this.pageIndex = val;
        this.getProductsList();
      }
    },

    checkboxChange() {
      if (this.checked2ndCategory.length == 0) {
        this.searchStatus = false
        this.pageIndex = 1
        this.pageTotal = 0
        this.getProductsList();
        return
      }
      this.searchStatus = true
      this.showProductList = []
      this.searchPageIndex = 1
      this.searchPageTotal = 0
      this.getSearch()
    },
    reset() {
      this.productList = []
      this.bannerList = []
      this.pageType = null
      this.pageIndex = 1
      this.pageTotal = 0
      this.showProductList = []
      this.searchStatus = false
      this.checked2ndCategory = []
    },
  },
  mounted() {
    this.categoryId = this.$route.query.categoryId
    this.getBannerList()
    this.getProductsList()
    this.$emit('set-search-bar', true)
  },
  components: {
    Swiper,
  },
  watch: {
    $route() {
      this.categoryId = this.$route.query.categoryId
      this.reset()
      this.getBannerList()
      this.getProductsList()
    },
  }
}
</script>


<style lang="scss" scoped>
@import '~@scss';

// 首页分类样式
section {
  padding-top: 40px;
  .header {
    line-height: 40px;
    h3 {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;
      display: inline-block;
    }
    .checkMore {
      float: right;
      font-style: 14px;
      cursor: pointer;
    }
  }
}

.checkProduct{
  width: 285px;
  min-height: 448px;
  // background-color: #f00;
  label{
    display: block;
    padding: 10px 0;
  }
  .checkbox + .checkbox {
    margin-left: 0;
  }
}

.product {
  width: 915px;
  overflow: hidden;
  li {
    float: left;
    width: 285px;
    height: 350px;
    margin-left: 20px;
    background-color: #fff;
    margin-bottom: 20px;
    .title {
      padding: 0 20px;
    }
    h4 {
      width: 100%;
      height: 24px;
      overflow: hidden;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 0;
      cursor: pointer;
    }
    .price {
      font-size: 20px;
      color: #de2c32;
    }
    img {
      width: 100%;
      height: 285px;
      cursor: pointer;
      border-radius: 4px 4px 0 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
}
.noProductList{
  min-height: 400px;
  font-size: 24px;
  display: flex;
  align-items:center;
  justify-content: center;
  div{
    text-align: center;
    width: 400px;
    height: 42px;
    i{
      width: 40px;
      height: 40px;
      font-size: 28px;
    }
  }
}

.pages{
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: center;
}
//公共样式
.in_b{
  display: inline-block;
}
.red{
  background-color: #d9262c;
  color:#fff;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
.pageStyle{
  text-align: center;
  margin-top: 76px;
}

</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/components/category/Category.vue